module.exports = __webpack_public_path__ + "img/icon_pencil.14c54068.png";